// Import model
import { ProposalCondition } from '../models/ProposalCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ProposalIndexedFields } from '../models/ProposalIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ProposalIndexedFieldsSerializer } from './ProposalIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProposalCondition - handles JSON serialization and deserialization with type validation
 */
export class ProposalConditionSerializer {
  /**
   * Deserializes a JSON string into a ProposalCondition instance
   */
  static deserialize(json: string): ProposalCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProposalCondition instance
   */
  static fromObject(obj: any): ProposalCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProposalCondition');
    }


    const instance: ProposalCondition = {
      fieldName: obj['fieldName'] as ProposalIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProposalCondition instances
   */
  static deserializeArray(json: string): ProposalCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProposalCondition instance to a JSON string
   */
  static serialize(instance: ProposalCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProposalCondition instance to a plain object
   */
  static toObject(instance: ProposalCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ProposalCondition instances to a JSON string
   */
  static serializeArray(instances: ProposalCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
